import {Error} from '@progress/kendo-react-labels';
import {Input, InputProps, InputHandle} from "@progress/kendo-react-inputs";
import React, {KeyboardEventHandler, useEffect, useRef, useState} from "react";
import "./FlintTextBox.scss";
import {FlintValidationData, GUID} from "@utils/AppConstants";


export default function FlintTextBox(props: FlintTextBoxProps) {
    const [visited, setVisited] = useState(false);
    const {onEnterPressed, validationData, ...other} = props;

    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        setVisited(true);
        validationData?.validateFunction?.(validationData?.optionalObjectToValidate).catch((err) => {});
        if (props.onBlur) {
            props.onBlur(event); // Call the parent's onBlur handler if provided
        }
    };

    const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (props.onEnterPressed && event.key === 'Enter') {
            event.stopPropagation();
            props.onEnterPressed(event); // Call the onEnterPressed handler
        }
        if (props.onKeyUp) {
            props.onKeyUp(event); // Call the parent's onKeyUp handler if provided
        }
    };
    
    return (
        <div className="flint-text-box">
            <Input
                {...other}
                valid={!validationData?.validationMessage}
                onBlur={handleBlur}
                onKeyUp={handleKeyUp}
            />
            {(!props.valid && props.validationMessage) && <Error>{props.validationMessage}</Error>}
            {validationData?.validationMessage != null && <Error>{validationData.validationMessage}</Error>}
        </div>
    );
}

export interface FlintTextBoxProps extends InputProps {
    onEnterPressed?: KeyboardEventHandler,
    validationData? : FlintValidationData
}
